import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'
import sortListStringNum from '../../../../helper/sortLIstStringNum'

// action
import { removeLoading, addLoading } from '../../../commonAction'

const apiGetListDetailsOfFingerAuth = `${host}admin/exportJSON/verifyBio`

export const getListDetailsOfFingerAuth = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    TellerName,
    SupervisorName,
    VerifyFingerStatus
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ReportCodeName,
        BranchName,
        TellerName,
        SupervisorName,
        VerifyFingerStatus
    })

    try {
        const res = await Axios.post(apiGetListDetailsOfFingerAuth, dataRequest)
        const { data } = res
        dispatch({
            type: types.GET_LIST_DETAILS_OF_FINGER_AUTH,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ReportCodeName,
                    BranchName,
                    TellerName,
                    SupervisorName,
                    VerifyFingerStatus
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_DETAILS_OF_FINGER_AUTH_ERROR,
            () => false
        )
    }
}

export const exportListDetailsOfFingerAuth = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    BranchCodes,
    TellerName,
    SupervisorName,
    VerifyFingerStatus
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
        TellerName,
        SupervisorName,
        VerifyFingerStatus
    })

    try {
        const res = await Axios.post(
            apiGetListDetailsOfFingerAuth,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${sortListStringNum(BranchCodes).join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
